export var FileExtensions;
(function (FileExtensions) {
    FileExtensions["MOL"] = "mol";
    FileExtensions["NMRIUM"] = "nmrium";
    FileExtensions["JSON"] = "json";
    FileExtensions["JCAMP"] = "jcamp";
    FileExtensions["DX"] = "dx";
    FileExtensions["JDX"] = "jdx";
    FileExtensions["JDF"] = "jdf";
    FileExtensions["ZIP"] = "zip";
    FileExtensions["NMREDATA"] = "nmredata";
})(FileExtensions || (FileExtensions = {}));
//# sourceMappingURL=constants.js.map